import React from 'react';
import MainContent from '../components/MainContent/MainContent';

const CalendrierPage: React.FC = () => {
  return (
    <>
      <MainContent />
    </>
  );
};

export default CalendrierPage;